import { EmbedCodeEditorComponent } from "../../../components/embed-code-components";


export const EmbedCode: React.FC = () => {
  return <EmbedCodeEditorComponent />;
};



